export default __webpack_public_path__ + "static/CDR-May18-462b85a78ae3ed3f529032ebb28d84d6.png";